import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, extendTheme } from "@chakra-ui/react"; // Importer extendTheme
import AppRouter from './AppRouter';
import mainTheme from './themes/Main';
import './i18n'; // Don't forget to import your i18n.js file
import { LoadScript } from '@react-google-maps/api';
import DelayedSpinner from './utils/Spinner';

// Étendre le thème pour ajouter les polices globales
const theme = extendTheme({
  ...mainTheme,
  fonts: {
    ...mainTheme.fonts,
    heading: "'Poppins', sans-serif",
    body: "'Poppins', sans-serif",
  },
});

// Ajouter la police Poppins au head
const poppinsLink = document.createElement('link');
poppinsLink.rel = 'stylesheet';
poppinsLink.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap';
document.head.appendChild(poppinsLink);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ChakraProvider theme={theme}> {/* Utiliser le thème étendu */}
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
      libraries={["places"]}
      loadingElement={<DelayedSpinner minDelay={100} />}
    >
      <AppRouter />
    </LoadScript>
  </ChakraProvider>
);

